import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_more",
  "use": "icon-icon_more-usage",
  "viewBox": "0 0 22 4",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 4\" id=\"icon-icon_more\"><g fill=\"#000\" fill-rule=\"evenodd\"><circle cx=\"2\" cy=\"2\" r=\"2\" /><circle cx=\"11\" cy=\"2\" r=\"2\" /><circle cx=\"20\" cy=\"2\" r=\"2\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol